var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-visualizer",class:{ active: _vm.isActive }},[_c('div',{staticClass:"visualizer-bars"},_vm._l((5),function(n){return _c('div',{key:n,staticClass:"bar"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }